<template>
    <nav
        class="nav justify-content-end bg-tfyoyellow border-bottom border-secondary-subtle border-2 text-end align-items-center py-3">
        <div class="admin--info">
            <h3 class="fw-semibold fs-5">{{ user }}</h3>
            <h4 class="d-block fs-6 mt-n1">Admin</h4>
        </div>
    </nav>
</template>

<script>
import { computed } from 'vue';
import { useStore } from 'vuex';

export default {
    setup() {
        return {
            user: computed(() => {
                // Get admin email
                const user = useStore().getters['auth/user'];
                return user ? user.email : '';
            })
        };
    }
}
</script>

<style scoped src="@/assets/css/admin.css"></style>